import { ref } from 'vue';

/** Globale teller van lopende requests (port van eportal LoadingService). */
class LoadingService {
  public readonly active = ref(0);
  start() {
    this.active.value++;
  }
  stop() {
    this.active.value = Math.max(0, this.active.value - 1);
  }
  get isLoading() {
    return this.active.value > 0;
  }
}
export const loadingService = new LoadingService();
